import { createElementBlock as l, openBlock as o, createElementVNode as n } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(d, e) {
  return o(), l("svg", r, e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.001 16a.999.999 0 1 0 1.998 0v-3.001H16A.999.999 0 1 0 16 11h-3.001V8a.999.999 0 0 0-1.998 0v3.001H8a.999.999 0 1 0 0 1.998h3.001z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const i = { render: t };
export {
  i as default,
  t as render
};
//# sourceMappingURL=ic_plus_sm-BwDiXfat.js.map
